<section class="title">
  <div class="max-w-[min(screen,960px)] text-center flex flex-col items-center gap-2 md:gap-3 leading-tight">
    <h1 class="tracking-tight font-semibold text-xl md:text-2xl lg:text-4xl">
      {{ titleKey() | translate }}
      @if (taglineKey(); as tagline) {
        <span class="block font-normal tracking-tight text-lg md:text-[22px] lg:text-[32px]">
          {{ tagline | translate }}
        </span>
      }
    </h1>
    <p class="text-gray-500 font-light tracking-tight text-md md:text-[20px] lg:text-[30px] max-w-240">
      {{ subtitleKey() | translate }}
    </p>
    <ng-content />
  </div>
</section>
